import { render, staticRenderFns } from "./sideCompany.vue?vue&type=template&id=1b3c204a&scoped=true&"
import script from "./sideCompany.vue?vue&type=script&lang=js&"
export * from "./sideCompany.vue?vue&type=script&lang=js&"
import style0 from "./sideCompany.vue?vue&type=style&index=0&id=1b3c204a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b3c204a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VList } from 'vuetify/lib/components/VList';
import { VListGroup } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VList,VListGroup,VListItem,VListItemContent,VListItemTitle})
